import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import MyNavBar from "./components/nav";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import Pricing from "./components/pricing";
import Features from "./components/features";
import Home from "./components/home";

function App() {
  return (
   <Home></Home>
  );
}

//  <BrowserRouter>
 
//       <MyNavBar></MyNavBar>
//       <div style={{marginTop:56+'px'}}>
//       <div >
//         <Switch>
//           <Route exact path="/pricing">
//             <Pricing></Pricing>
//           </Route>

//           <Route exact path="/features">
//             <Features></Features>
//           </Route>

//           <Route exact path="/home">
//             <Home></Home>
//           </Route>
//         </Switch>
//       </div>
//     </BrowserRouter>


export default App;
